import { sessionConstants } from '../constants';

const initialState = { };

export function session(state=initialState,action) {
    switch(action.type) {
        case sessionConstants.UPDATESESSION_REQUEST:
      return {
        data: action.data,
        
      };
      case sessionConstants.UPDATESESSION_FAILURE:
      return {
        data: action.data,
    
      };
      case sessionConstants.UPDATESESSION_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
      case sessionConstants.GETSESSION_REQUEST:
      return {
        videoData: action.videoData,
        
      };
      case sessionConstants.GETSESSION_FAILURE:
      return {
        videoData: action.videoData,
    
      };
      case sessionConstants.GETSESSION_SUCCESS:
        return {
          ...state,
          videoData: action.videoData,
        };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/session.reducer.js